/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1AssociatedcompanyIdAttachment200,
  PostApiV1AssociatedcompanyIdAttachment400,
  PostApiV1AssociatedcompanyIdAttachment401,
  PostApiV1AssociatedcompanyIdAttachment404,
  PostApiV1AssociatedcompanyIdAttachment500,
  PostApiV1AssociatedcompanyIdAttachmentMutationRequest,
  PostApiV1AssociatedcompanyIdAttachmentMutationResponse,
  PostApiV1AssociatedcompanyIdAttachmentPathParams,
} from "../../types/associatedCompanyAttachmentController/PostApiV1AssociatedcompanyIdAttachment.ts";
import { associatedCompanyAttachmentViewModelSchema } from "../associatedCompanyAttachmentViewModelSchema.ts";

export const postApiV1AssociatedcompanyIdAttachmentPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachmentPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1AssociatedcompanyIdAttachment200Schema = z.lazy(
  () => associatedCompanyAttachmentViewModelSchema,
) as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachment200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1AssociatedcompanyIdAttachment400Schema =
  z.any() as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachment400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1AssociatedcompanyIdAttachment401Schema =
  z.any() as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachment401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1AssociatedcompanyIdAttachment404Schema =
  z.any() as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachment404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1AssociatedcompanyIdAttachment500Schema =
  z.any() as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachment500>;

export const postApiV1AssociatedcompanyIdAttachmentMutationRequestSchema =
  z.object({
    file: z.optional(z.instanceof(File)),
  }) as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachmentMutationRequest>;

export const postApiV1AssociatedcompanyIdAttachmentMutationResponseSchema =
  z.lazy(
    () => postApiV1AssociatedcompanyIdAttachment200Schema,
  ) as unknown as ToZod<PostApiV1AssociatedcompanyIdAttachmentMutationResponse>;
